var map = {
	"./box.png": 64484,
	"./dropbox.png": 2250,
	"./google_workspace.svg": 5429,
	"./icons-dark/IDrive logo.png": 36831,
	"./icons-dark/google-workspace.png": 91042,
	"./icons-dark/google-workspace.svg": 10671,
	"./icons-dark/logo-color.svg": 12937,
	"./icons-disabled/icons/activity-logs.svg": 33269,
	"./icons-disabled/icons/admin.svg": 77363,
	"./icons-disabled/icons/backup-now.svg": 57003,
	"./icons-disabled/icons/calendar.svg": 46752,
	"./icons-disabled/icons/calender-icon.svg": 93226,
	"./icons-disabled/icons/classes.svg": 11368,
	"./icons-disabled/icons/close-icon.svg": 84954,
	"./icons-disabled/icons/contacts.svg": 58417,
	"./icons-disabled/icons/delete-icon.svg": 35109,
	"./icons-disabled/icons/download.svg": 96179,
	"./icons-disabled/icons/drives.svg": 47682,
	"./icons-disabled/icons/edit.svg": 14952,
	"./icons-disabled/icons/groups.svg": 12059,
	"./icons-disabled/icons/mail.svg": 47382,
	"./icons-disabled/icons/overview.svg": 92306,
	"./icons-disabled/icons/recovery-menu.svg": 76084,
	"./icons-disabled/icons/recovery.svg": 56706,
	"./icons-disabled/icons/refresh.svg": 80467,
	"./icons-disabled/icons/responsive-restore-icon.svg": 31013,
	"./icons-disabled/icons/responsive-search-icon.svg": 42698,
	"./icons-disabled/icons/responsive-user-icon.svg": 17912,
	"./icons-disabled/icons/search.svg": 71212,
	"./icons-disabled/icons/seat-management.svg": 2538,
	"./icons-disabled/icons/setting.svg": 83001,
	"./icons-disabled/icons/settings.svg": 67375,
	"./icons-disabled/icons/user-icon.svg": 15184,
	"./icons-disabled/icons/users.svg": 74828,
	"./icons/Restore-icon.svg": 53268,
	"./icons/activity-logs.svg": 60235,
	"./icons/admin-red.svg": 19231,
	"./icons/admin.svg": 98965,
	"./icons/administrators-color.svg": 53527,
	"./icons/administrators.svg": 51595,
	"./icons/arrow-caret-down.svg": 57629,
	"./icons/arrow-caret-right.svg": 70774,
	"./icons/arrow-down.svg": 49072,
	"./icons/arrow-up.svg": 48641,
	"./icons/arrow_01.svg": 22112,
	"./icons/arrow_02.svg": 13509,
	"./icons/arrowscroll-hover.svg": 73226,
	"./icons/arrowscroll.svg": 86412,
	"./icons/avatar.svg": 84306,
	"./icons/backup-color.svg": 34127,
	"./icons/backup-now.svg": 94801,
	"./icons/backup.svg": 34550,
	"./icons/business_backup.svg": 53245,
	"./icons/business_backup_box.svg": 38840,
	"./icons/business_backup_dropbox.svg": 48967,
	"./icons/calendar-table.svg": 92539,
	"./icons/calendar.svg": 83231,
	"./icons/calender-icon.svg": 59444,
	"./icons/cancel-icon.svg": 88955,
	"./icons/cancel-status-icon.svg": 46055,
	"./icons/caret-down.svg": 41237,
	"./icons/chat-table.svg": 13449,
	"./icons/chat.svg": 5764,
	"./icons/classes-icon.svg": 43409,
	"./icons/classes.svg": 23656,
	"./icons/close-icon-dark.svg": 93825,
	"./icons/close-icon.svg": 58883,
	"./icons/compare.png": 17814,
	"./icons/compare.svg": 10881,
	"./icons/contact-table.svg": 12773,
	"./icons/contacts.svg": 93112,
	"./icons/data-backup.svg": 97076,
	"./icons/delete-bin-color.svg": 64354,
	"./icons/delete-bin.svg": 41206,
	"./icons/delete-icon.svg": 79524,
	"./icons/down-arrow-white.svg": 70630,
	"./icons/down-arrow.svg": 1776,
	"./icons/download-color.svg": 47615,
	"./icons/download-lightgray.svg": 36604,
	"./icons/download.svg": 52219,
	"./icons/drives.svg": 14480,
	"./icons/dropdown.svg": 59311,
	"./icons/edit-color.svg": 68796,
	"./icons/edit.svg": 30140,
	"./icons/error.svg": 43646,
	"./icons/exchange-onselect.svg": 57585,
	"./icons/exchange.svg": 32068,
	"./icons/export-color.svg": 3083,
	"./icons/export.svg": 51327,
	"./icons/exports-color.svg": 57735,
	"./icons/exports.svg": 74880,
	"./icons/fail.svg": 69703,
	"./icons/failuer-icon.svg": 65075,
	"./icons/folder shortcut.svg": 25485,
	"./icons/folder.svg": 27104,
	"./icons/groups.svg": 28674,
	"./icons/help icon.svg": 89757,
	"./icons/info-lighten.svg": 79721,
	"./icons/info-white.svg": 80397,
	"./icons/info.svg": 55517,
	"./icons/logout.svg": 4941,
	"./icons/mail.svg": 88494,
	"./icons/marketplace-icon.svg": 13148,
	"./icons/na.svg": 11433,
	"./icons/no-results-img.jpeg": 1690,
	"./icons/onedrive-onselect.svg": 79248,
	"./icons/onedrive.svg": 67869,
	"./icons/overview-classes.svg": 43799,
	"./icons/overview-color.svg": 47961,
	"./icons/overview-shared-mailboxes.svg": 94795,
	"./icons/overview-sites.svg": 12638,
	"./icons/overview-teams.svg": 26048,
	"./icons/overview-total-seats-for-backup-365.svg": 29135,
	"./icons/overview-total-seats-for-backup-google.svg": 87885,
	"./icons/overview-user.svg": 77249,
	"./icons/overview.svg": 44475,
	"./icons/pending-icon.svg": 45793,
	"./icons/personal_backup.svg": 48276,
	"./icons/personal_backup_box.svg": 77380,
	"./icons/personal_backup_dropbox.svg": 82301,
	"./icons/plus-icon.svg": 95547,
	"./icons/protected-data.svg": 59555,
	"./icons/question-mark.svg": 32671,
	"./icons/recovery-color.svg": 28004,
	"./icons/recovery-menu.svg": 33639,
	"./icons/recovery.svg": 33596,
	"./icons/recurring_calendar.svg": 54575,
	"./icons/refresh.svg": 26794,
	"./icons/responsive-restore-icon.svg": 78643,
	"./icons/responsive-search-icon.svg": 23998,
	"./icons/responsive-user-icon.svg": 40679,
	"./icons/restore-color.svg": 15945,
	"./icons/restore.svg": 45538,
	"./icons/restores-color.svg": 6913,
	"./icons/restores.svg": 74201,
	"./icons/right-arrow.svg": 80309,
	"./icons/salesforce_production_backup.svg": 32867,
	"./icons/salesforce_sandbox_backup.svg": 61669,
	"./icons/search-.svg": 35344,
	"./icons/search-color.svg": 55899,
	"./icons/search.svg": 40590,
	"./icons/seat-management-color.svg": 17313,
	"./icons/seat-management.svg": 2060,
	"./icons/setting.svg": 80220,
	"./icons/settings-gray.svg": 30139,
	"./icons/settings.svg": 28726,
	"./icons/shared-drives-icon.svg": 95032,
	"./icons/shared-drives.svg": 98932,
	"./icons/shared-folders.svg": 60068,
	"./icons/sharepoint-onselect.svg": 40680,
	"./icons/sharepoint.svg": 65802,
	"./icons/snapshort-icon.svg": 49141,
	"./icons/sort-icon.svg": 97326,
	"./icons/success-icon.svg": 67903,
	"./icons/success.svg": 92748,
	"./icons/sync-icon.svg": 60872,
	"./icons/teams-onselect.svg": 22949,
	"./icons/teams.svg": 8230,
	"./icons/theme_dark.svg": 6699,
	"./icons/theme_light.svg": 31985,
	"./icons/tick-error-icon.svg": 22895,
	"./icons/tick-icon.svg": 62137,
	"./icons/tick.svg": 45643,
	"./icons/up-arrow-white.svg": 99576,
	"./icons/up-arrow.svg": 57276,
	"./icons/user-icon.svg": 88728,
	"./icons/user.svg": 68262,
	"./icons/users-1.svg": 96408,
	"./icons/users-color.svg": 44498,
	"./icons/users-green.svg": 14259,
	"./icons/users.svg": 3015,
	"./images/Gsuite-sprite-image-mail.svg": 69241,
	"./images/dropbox-animation-images.svg": 49310,
	"./images/idrive-loader-dark.gif": 86252,
	"./images/idrive-loader.gif": 75332,
	"./images/idrive-loader_dark-theme.gif": 40430,
	"./images/laptop-icon.svg": 494,
	"./images/welcome-screen-dropbox-box.png": 32517,
	"./images/welcome-screen-microsoft.png": 9239,
	"./images/welcome-screen.png": 50311,
	"./microsoft_logo.svg": 177,
	"./salesforce.png": 6044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65255;